export const persistedName = "project_qa_paint_inspections_new";
